module.exports = __webpack_public_path__ + "static/img/user1.b93bd316.jpg";